/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import { WEB_RESOURCE_MAP } from '@jira/global-pages__dashboard-common/src/constants.tsx';
import type {
	GadgetData,
	WebResourceName,
} from '@jira/global-pages__dashboard-common/src/types.tsx';
// isReactKey is just a type guard, nothing controversial
// eslint-disable-next-line jira/import-whitelist
import {
	type ReactKey,
	type ReactGadgetIdentity,
	isReactKey,
} from '@jira/global-pages__dashboard-react-gadgets-definition/src/main.tsx';

export const gadgetsToUniqueSortedAmdModules = (gadgets: GadgetData[]): WebResourceName[] =>
	gadgets // oxlint-disable-next-line typescript/consistent-type-assertions
		.map(({ amdModule }) => amdModule as WebResourceName) // validated below
		.filter(Boolean)
		.filter((amdModule) => amdModule in WEB_RESOURCE_MAP)
		.filter((v, i, a) => a.indexOf(v) === i)
		.sort() ?? [];

export const gadgetsToSortedReactGadgets = (gadgets: GadgetData[]): ReactGadgetIdentity[] =>
	gadgets
		.reduce<Array<ReactGadgetIdentity>>((gadgetsAccumulator, gadget) => {
			if (!isReactKey(gadget.reactKey)) return gadgetsAccumulator;
			gadgetsAccumulator.push({
				// oxlint-disable-next-line typescript/consistent-type-assertions
				reactKey: gadget.reactKey as ReactKey,
				id: gadget.id,
				userPrefs: gadget.userPrefs,
			});
			return gadgetsAccumulator;
		}, [])
		.sort((a, b) => a.id.localeCompare(b.id));
